import { render, staticRenderFns } from "./SithMesInventoryReceiptReturnRecordList.vue?vue&type=template&id=6784b4ec&"
import script from "./SithMesInventoryReceiptReturnRecordList.vue?vue&type=script&lang=js&"
export * from "./SithMesInventoryReceiptReturnRecordList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports